import objectPrefix from '../../lib/objectPrefix';

const prefix = objectPrefix();

module.exports = {

    pumperMan1: {
        type: 'movieclip',
        scale: {
            x: '100%',
        },
        position: {
            x: '-6%',
            y: '11%',
        },
        texture: `sprite:/img/partials/pumpers/man/1-${prefix}.json`,
        particles: [
            {
                x: '80.8%',
                y: '18.7%',
                angle: 330,
                emit: true,
            },
            {
                x: '80.2%',
                y: '18.5%',
                angle: 330,
                emit: false,
            },
            {
                x: '79.4%',
                y: '18.6%',
                angle: 330,
                emit: false,
            },
            {
                x: '80.7%',
                y: '18.8%',
                angle: 330,
                emit: false,
            },
            {
                x: '81.4%',
                y: '18.9%',
                angle: 330,
                emit: false,
            },
            {
                x: '80.4%',
                y: '18.8%',
                angle: 330,
                emit: true,
            },
            {
                x: '80.2%',
                y: '19.2%',
                angle: 330,
                emit: false,
            },
            {
                x: '80.1%',
                y: '19%',
                angle: 330,
                emit: false,
            },
            {
                x: '82.2%',
                y: '18.5%',
                angle: 330,
                emit: false,
            },
            {
                x: '83.3%',
                y: '18.4%',
                angle: 330,
                emit: true,
            },
            {
                x: '82.7%',
                y: '18.3%',
                angle: 330,
                emit: false,
            },
            {
                x: '82.2%',
                y: '18.4%',
                angle: 330,
                emit: false,
            },
            {
                x: '83.1%',
                y: '18.5%',
                angle: 330,
                emit: false,
            },
        ],
    },

    pumperMan2: {
        type: 'movieclip',
        scale: {
            x: '100%',
        },
        position: {
            x: '-6%',
            y: '11%',
        },
        texture: `sprite:/img/partials/pumpers/man/2-${prefix}.json`,
        particles: [
            {
                x: '87.8%',
                y: '21.3%',
                angle: 330,
                emit: false,
            },
            {
                x: '88.8%',
                y: '21.5%',
                angle: 330,
                emit: false,
            },
            {
                x: '89.6%',
                y: '19.7%',
                angle: 330,
                emit: true,
            },
            {
                x: '95.7%',
                y: '21%',
                angle: 330,
                emit: false,
            },
            {
                x: '95.2%',
                y: '21.2%',
                angle: 330,
                emit: false,
            },
            {
                x: '95.1%',
                y: '21.4%',
                angle: 330,
                emit: false,
            },
            {
                x: '95.6%',
                y: '21.6%',
                angle: 330,
                emit: false,
            },
            {
                x: '95%',
                y: '19.9%',
                angle: 330,
                emit: true,
            },
            {
                x: '94.5%',
                y: '19.4%',
                angle: 330,
                emit: false,
            },
            {
                x: '95.3%',
                y: '20.7%',
                angle: 330,
                emit: false,
            },
            {
                x: '105%',
                y: '21.6%',
                angle: 330,
                emit: false,
            },
            {
                x: '106%',
                y: '21.1%',
                angle: 330,
                emit: false,
            },
            {
                x: '92.9%',
                y: '20.8%',
                angle: 330,
                emit: true,
            },
            {
                x: '92.2%',
                y: '21%',
                angle: 330,
                emit: false,
            },
            {
                x: '93.4%',
                y: '21.3%',
                angle: 330,
                emit: false,
            },
        ],
    },

    pumperMan3: {
        type: 'movieclip',
        scale: {
            x: '100%',
        },
        position: {
            x: '-6%',
            y: '11%',
        },
        texture: `sprite:/img/partials/pumpers/man/3-${prefix}.json`,
        particles: [
            {
                x: '78.4%',
                y: '18.4%',
                angle: 320,
                emit: true,
            },
            {
                x: '79.9%',
                y: '19.2%',
                angle: 320,
                emit: false,
            },
            {
                x: '79.6%',
                y: '19.3%',
                angle: 320,
                emit: false,
            },
            {
                x: '79.8%',
                y: '19.2%',
                angle: 320,
                emit: false,
            },
            {
                x: '80.6%',
                y: '18.2%',
                angle: 320,
                emit: true,
            },
            {
                x: '80.3%',
                y: '18.5%',
                angle: 320,
                emit: false,
            },
            {
                x: '80.9%',
                y: '17.8%',
                angle: 320,
                emit: true,
            },
            {
                x: '81.1%',
                y: '17.9%',
                angle: 320,
                emit: false,
            },
            {
                x: '82%',
                y: '18.4%',
                angle: 320,
                emit: true,
            },
            {
                x: '81.6%',
                y: '18.4%',
                angle: 320,
                emit: false,
            },
            {
                x: '81.9%',
                y: '18.5%',
                angle: 320,
                emit: true,
            },
            {
                x: '82.9%',
                y: '18.3%',
                angle: 320,
                emit: false,
            },
            {
                x: '84.6%',
                y: '18.5%',
                angle: 320,
                emit: false,
            },
            {
                x: '86.9%',
                y: '19.2%',
                angle: 320,
                emit: false,
            },
            {
                x: '87.1%',
                y: '20.4%',
                angle: 320,
                emit: true,
            },
        ],
    },

    manPump: {
        scale: {
            x: '100%',
        },
        position: {
            x: '-6%',
            y: '11%',
        },
        texture: '/img/partials/pumpers/man/pump.png',
    },

    manPumpBackground: {
        scale: {
            x: '100%',
        },
        texture: '/img/partials/pumpers/man/bg.jpg',
    },

};



// WEBPACK FOOTER //
// ./js/objects/partials/manPump.js